import React from "react";
import Image from "../sharedUI/Image/Image";
import Popup from "../sharedUI/popup";
import ReactHtmlParser from 'react-html-parser';
import BenefitClasses from './BenefitPopup.module.scss'
import bottomImage from '../../assets/images/pan.png';
import { getOracleCTAClick } from "../../shared/AdobeUtility"
import { useSelector } from "react-redux";
import { isPartnersWithCustomTheme, getPartnerName } from "../../shared/PartnerUtility";;
const Benefit = ({ classes, togglePopup }) => {
  const currentAppState = useSelector((state) => state.AppState);
  const cardListDetails = useSelector(state => state.AppState?.cardListDetails ? state.AppState.cardListDetails : null);
  const imageUrl = useSelector((state) =>
    state.AppState?.cardListDetails?.frontImage
      ? state.AppState.cardListDetails.frontImage
      : state.AppState.cardListDetails.image
  );

  const partner = getPartnerName();
  const bgColorDetails = {
    tataneu:   BenefitClasses.benefitListUlTata,
    yono:     BenefitClasses.benefitListUlYono,
    default: BenefitClasses.benefitListUl
  };
  const themebgColorDetails = partner && isPartnersWithCustomTheme(partner) ? bgColorDetails[partner] : bgColorDetails.default;
  return <Popup
    isCustom={true}
    PopupBox={classes.PopupBox}
    // header={<span className={classes.CloseIcon} onClick={togglePopup}>
    //   <Image filename={"close_black_-1"} ext={"png"} renditions={["2x"]} />
    // </span>}

    Box={classes.Box}
    CloseBtn={classes.CloseBtnPopUp}
    content={
      <>
        <div className={BenefitClasses.benefitHeader}>
          <span>Card Benefits</span>
          <span className={BenefitClasses.CloseIcon} onClick={() => { togglePopup(); getOracleCTAClick("view-benifits", currentAppState, "View Benifits Close") }}>
            <Image filename={"close_black_-1"} ext={"png"} renditions={["2x"]} />
          </span>
        </div>
        <div className={BenefitClasses.benefitContent}>
          <div className={BenefitClasses.imgSection}>

            <img
              src={`${window.location.origin}${imageUrl}`}
              className={BenefitClasses.frontImage}
              alt=""
            />
            <img
              src={bottomImage}
              className={BenefitClasses.bottomImage}
              alt=""
            />
          </div>
          <div className={BenefitClasses.benefitListSection  +" "+ themebgColorDetails}>
            <h3 className={BenefitClasses.cardName}>{cardListDetails?.name ? cardListDetails.name : "Air India SBI Platinum Card"}</h3>
            {cardListDetails?.eapplyBenefits ? ReactHtmlParser(cardListDetails.eapplyBenefits) : ""}

          </div>

        </div>

        {/* <h3 className={classes.CardNamePopUp}>
          {cardListDetails?.name ? cardListDetails.name : "Air India SBI Platinum Card"}
        </h3>
        {cardListDetails?.eapplyBenefits ? ReactHtmlParser(cardListDetails.eapplyBenefits) : ""} */}
      </>
    }
    filename={' '}
    ext={"png"}
    renditions={["2x"]}
    handleClose={togglePopup}
    buttonLabel="Okay"
  />
}
export default Benefit